import React from "react";
import getColorSwatchComponentBySkin from "./components/option-skins";
export const ColorSwatchOptions = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (event) => {
        props?.onChanged?.(event);
    };
    const ColorSwatchComponent = getColorSwatchComponentBySkin(props.skin ?? "standard");
    const buttonProps = { ...props, onChanged: onChangeHandler };
    return React.createElement(ColorSwatchComponent, { ...buttonProps });
};
//# sourceMappingURL=color-swatch-options.js.map